<template>
    <div>
        <img v-if="downloadKey" :src="srcWithKey" :class="imgclass" >
        <div v-else class="spinner-border text-dark" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template >

<script>
    import { reportsApiService } from '@/services/reports-api.service.js'

    export default {
        name: 'imgWithKey',
        props: {
            imgsrc: String,
            imgclass: String
        },
        data: () => ({
            downloadKey: null,            
        }),
        mounted () {
            this.getKey()
        },
        methods: {
            getKey() {
                
                reportsApiService.getDownloadKey()
                    .then(response => {
                        this.downloadKey = response.data
                    })
                    .catch(error => {
                        console.log(error)
                        return null
                    })
            }
        },
        computed: {
            srcWithKey() {
                return  this.imgsrc + '/' + this.downloadKey
            }
        }
    }
</script>

    